import { api } from '../api';

export interface ScheduledTask {
  id: string;
  name: string;
  buildingId: string;
  type: 'MONTHLY_SERVICE_FEE' | 'PAYMENT_REMINDER' | 'OVERDUE_NOTICE';
  status: 'ACTIVE' | 'INACTIVE' | 'COMPLETED' | 'FAILED';
  lastRun?: string;
  nextRun?: string;
  executionDay: number;
  config?: any;
  createdAt: string;
  updatedAt: string;
  building?: {
    name: string;
  };
}

export interface TriggerResponse {
  success: boolean;
  message: string;
}

export interface TriggerMonthlyServiceFeeOptions {
  apartmentGroupIds?: string[];
  apartmentIds?: string[];
  deliveryMethods?: string[];
  mode?: 'MONTHLY_FEE' | 'DEBT_REMINDER';
}

export const scheduledTasksApi = {
  // Manually trigger monthly service fee generation for a building
  triggerMonthlyServiceFeeGeneration: async (
    buildingId: string,
    options?: TriggerMonthlyServiceFeeOptions,
  ): Promise<TriggerResponse> => {
    const response = await api.post(
      `/scheduled-tasks/trigger/monthly-service-fee/${buildingId}`,
      options ?? {},
    );
    return response.data;
  },

  // Get scheduled tasks status
  getScheduledTasks: async (buildingId?: string): Promise<ScheduledTask[]> => {
    const params = buildingId ? { buildingId } : {};
    const response = await api.get('/scheduled-tasks/status', { params });
    return response.data;
  },
}; 